import { Theme } from '@mui/material/styles';

// ==============================|| CUSTOM FUNCTION - COLOR SHADOWS ||============================== //

export default function getShadow(theme: Theme, shadow: string): string {
  const cs = theme.vars!.customShadows;
  switch (shadow) {
    case 'secondary':
      return cs.secondary;
    case 'error':
      return cs.error;
    case 'warning':
      return cs.warning;
    case 'info':
      return cs.info;
    case 'success':
      return cs.success;
    case 'primaryButton':
      return cs.primaryButton;
    case 'secondaryButton':
      return cs.secondaryButton;
    case 'errorButton':
      return cs.errorButton;
    case 'warningButton':
      return cs.warningButton;
    case 'infoButton':
      return cs.infoButton;
    case 'successButton':
      return cs.successButton;
    default:
      return cs.primary;
  }
}
